import { kuiperClassNames } from '@opallabs/kuiper'
import { formattedDateObject } from '../../../../helpers/dateHelpers'

const DATE_FORMAT_LONG = 'MMM D, YYYY h:mm A'

function dialogue(message, completedAt) {
  return (
    <div className={kuiperClassNames('phase-popover', 'n10')}>
      <div className={kuiperClassNames('popover-text')}>{message}</div>
      <div className={kuiperClassNames('popover-date', 'n10')}>
        {formattedDateObject(completedAt, DATE_FORMAT_LONG)}
      </div>
    </div>
  )
}

export const renderAvatarCompletedDialogue = (toUser, completedAt) => {
  const message = `This task was completed by ${toUser.fullName}`
  return dialogue(message, completedAt)
}

export const renderAvatarCompletedByProxyDialogue = (
  toUser,
  proxyUser,
  completedAt
) => {
  const message = `This task was completed by ${proxyUser.fullName} on behalf of ${toUser.fullName}`
  return dialogue(message, completedAt)
}

export const renderIntegrationCompletedDialogue = (
  integrationName,
  completedAt
) => {
  const message = `This task was completed through ${integrationName}`
  return dialogue(message, completedAt)
}

export const renderIntegrationCompletedByProxyDialogue = (
  toUser,
  integrationName,
  completedAt
) => {
  const message = `This task was completed by ${toUser.fullName}, originally sent to ${integrationName}`
  return dialogue(message, completedAt)
}
